export const _setOrgId = (state, action) => {
  state.orgId = action.payload;
};

export const _setAddress = (state, action) => {
  state.address = action.payload;
};

export const _setState = (state, action) => {
  state.state = action.payload;
};

export const _setOrgCity = (state, action) => {
  state.orgCity = action.payload;
};

export const _setZip = (state, action) => {
  state.zip = action.payload;
};

export const _setCountyId = (state, action) => {
  state.countyId = action.payload;
};

export const _setSascaRegion = (state, action) => {
  state.sascaRegion = action.payload;
};

export const _setPostalAddress = (state, action) => {
  state.postalAddress = action.payload;
};

export const _setPostalCity = (state, action) => {
  state.postalCity = action.payload;
};

export const _setPostalZip = (state, action) => {
  state.postalZip = action.payload;
};

export const _setCommPhone = (state, action) => {
  state.commPhone = action.payload;
};

export const _setCommFax = (state, action) => {
  state.commFax = action.payload;
};

export const _setCommEmail = (state, action) => {
  state.commEmail = action.payload;
};

export const _setCommWeb = (state, action) => {
  state.commWeb = action.payload;
};
